import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy
} from '@angular/router';

/**
 * Recreates a route's component when its params change, for routes marked with
 * `data: { recreateOnParamChange: true }`. Every other route keeps Angular's default
 * reuse. Registered as the RouteReuseStrategy in AppModule; it applies on every
 * navigation. Used by components that read their params from the route snapshot only
 * once, such as the manual view opened from the hover sub-navigation. A route's flag
 * can be removed once its component reacts to param changes itself.
 */
@Injectable()
export class ParamAwareRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    if (!super.shouldReuseRoute(future, curr)) return false;
    if (future.data['recreateOnParamChange'] !== true) return true;
    return JSON.stringify(future.params) === JSON.stringify(curr.params);
  }
}
